import * as React from "react";

// packages/ui stays router-agnostic: an app provides the component that turns an href into a client-side navigation
// (the console wraps TanStack Router's Link). Without a provider, links are plain anchors.
export type LinkComponent = React.ComponentType<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; ref?: React.Ref<HTMLAnchorElement> }
>;

const PlainLink: LinkComponent = (props) => <a {...props} />;

const LinkContext = React.createContext<LinkComponent>(PlainLink);

export function LinkProvider({ component, children }: { component: LinkComponent; children: React.ReactNode }) {
  return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}

/** An in-app link rendered through the provided router link. */
export function AppLink(props: React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const Comp = React.useContext(LinkContext);
  return <Comp {...props} />;
}
